<template>
    <div>
        <main class="password-recover">
            <Breadcrumb :breadcrumb="breadcrumb"/>
            <section class="pb-5">
                <b-container>
                    <b-row>
                        <b-col cols="12">
                            <div class="password-recover-block mt-5">
                                <div class="login_register--wrap restricted_area--wrap order-md-2">
                                    <h2 class="password-recover-title pb-2">Alterar senha</h2>
                                    <p>
                                        Você solicitou uma alteração de senha. Utilize o formulário para alterá-la.
                                    </p>
                                    <p>
                                        Crie uma nova senha com no mínimo 6 caracteres,
                                        combinando letras minúsculas, maiúsculas e números
                                    </p>
                                    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
                                        <form action="#" method="post" name="change_password_form" class="form_default mt-5" @submit.prevent="handleSubmit(onSubmit)">
                                            <b-row>
                                                <b-col cols="6">
                                                    <ValidationProvider name="nova senha" rules="required|password" vid="new_password" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="change_password_new_password" class="password-recover-change-label">Nova senha</label>
                                                            <InputPassword id="change_password_new_password" :classes="classes" v-model="new_password" autocomplete="new-password"/>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="6">
                                                    <ValidationProvider name="repita a nova senha" rules="required|confirmed:new_password" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="change_password_confirm_new_password" class="password-recover-change-label">Repita a nova senha </label>
                                                            <InputPassword id="change_password_confirm_new_password" :classes="classes" v-model="conf_new_password"/>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <recaptcha :data-sitekey="$wdconfig.default.recaptcha_site" v-if="$wdconfig.default.recaptcha"/>
                                            <FormMessage :msg="msg_form" :type="msg_form_type"></FormMessage>
                                            <div class="d-flex justify-content-end mt-5 mb-4">
                                                <button type="submit" class="btn-default btn-square" :disabled="sending || !valid_token">
                                                    {{ sending ? 'Enviando' : 'Alterar senha' }}
                                                </button>
                                            </div>
                                        </form>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
        </main>
        <Footer/>
    </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import FormMessage from "~/components/FormMessage";
import InputPassword from "~/components/Input-password.vue";

export default {
    components: {
        Breadcrumb,
        ValidationProvider,
        ValidationObserver,
        FormMessage,
        InputPassword
    },
    head() {
        return {
            title: 'Alterar senha - Minha conta - Central Sul RG',
            meta: [
                {hid: 'og:image', property: 'og:image', content: 'https://' + this.host + '/share.jpg'},
                {hid: 'og:image:height', property: 'og:image:height', content: '315'},
                {hid: 'og:image:width', property: 'og:image:width', content: '600'},
                {hid: 'og:url', property: 'og:url', content: 'https://' + this.host + this.$route.fullPath}
            ]
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.sending = true;
                const params = new URLSearchParams();
                params.append('new_password', this.new_password);
                params.append('token', this.token);
                if (this.$wdconfig.default.recaptcha) {
                    params.append('g-recaptcha-response', await this.$recaptcha.getResponse());
                }
                return this.$axios.$post(`index.php?obj=auth&method=changePasswordForToken`, params)
                    .then((response) => {
                        this.sending = false;
                        if (response.status === 'success') {
                            if (response.data.status === 'success') {
                                this.msg_form = 'Senha alterada. Você será redirecionando a página de login';
                                this.msg_form_type = 'success';
                                setTimeout(() => {
                                    this.$router.push('/login')
                                }, 5000);
                            } else {
                                throw response.data.message;
                            }
                        } else {
                            throw response.message;
                        }
                    })
                    .catch((e) => {
                        if (this.$wdconfig.default.recaptcha) {
                            this.$recaptcha.reset();
                        }
                        this.sending = false;
                        this.msg_form = e;
                        this.msg_form_type = 'error';
                    })
            } catch (error) {
                if (this.$wdconfig.default.recaptcha) {
                    this.$recaptcha.reset();
                }
                this.sending = false;
                this.msg_form = 'Não foi possível alterar a senha';
                this.msg_form_type = 'error';
            }
        }
    },
    data: () => ({
        new_password: '',
        conf_new_password: '',
        msg_form: '',
        msg_form_type: '',
        sending: false,
        token: '',
        valid_token: ''
    }),
    computed: {
        breadcrumb() {
            return [
                {
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Alterar senha',
                    link: null
                }
            ]
        }
    },
    async fetch() {
        const params = new URLSearchParams();
        params.append('token', this.token);
        await this.$axios.$post(`index.php?obj=auth&method=validTokenChangePassword`, params).then((res) => {
            this.valid_token = res.status === 'success'
            if (!this.valid_token) {
                this.msg_form = res.message
                this.msg_form_type = 'error'
            }
        });
    },
    async asyncData({params, query, res, $axios, req, app}) {
        try {
            return {
                token: query.token
            }
        } catch (e) {
            console.error(e)
            return error({statusCode: 404, message: e.message})
        }
    }
}
</script>
